var _style, _path, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTheta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 822.8",
    style: {
      enableBackground: "new 0 0 1000 822.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 80.0333,
    y1: 693.0502,
    x2: 857.7128,
    y2: 693.0502
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF00BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5139,
    style: {
      stopColor: "#FF0200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A12CFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M728.7,563.3c-54.9,88.5-152.4,144.4-259.9,144.4c-107.5,0-204.9-55.9-259.9-144.4H80 c64.9,156.4,217.6,259.5,388.8,259.5c171.3,0,324-103.2,388.8-259.5H728.7z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M147.3,463.3c-84,0-147.3-39-147.3-106.5h103.5c0,23.7,17.7,35.3,41.4,35.3c20.7,0,32.9-7.3,32.9-21.9 c0-49.3-172.3,1.8-172.3-126c0-62.1,57.2-97.4,132.7-97.4c81,0,141.9,45.1,141.9,103.5H176.6c0-18.3-15.2-32.3-35.9-32.3 c-17.7,0-29.8,7.3-29.8,20.1c0,44.5,174.7-2.4,174.7,124.8C285.6,427.3,226.5,463.3,147.3,463.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.9,414c-17.1,31.7-49.3,49.3-88.9,49.3c-60.3,0-104.7-36.5-104.7-110.2V152.8H749v169.9 c0,33.5,12.2,49.3,34.7,49.3c23.7,0,35.3-15.8,35.3-49.3V152.8h118.7v304.4H823.9V414z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "534.8,289.7 619.4,152.8 488.5,152.8 424,278.2 424,0 305.3,60 305.3,457.2 424,457.2 424,301.3  494,457.2 623.7,457.2  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M968.7,157.5h-6.9v24H956v-24h-7v-4.8h20.7L968.7,157.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.3,181.5l-1.1-15.4c-0.1-1.8-0.2-3.3-0.2-4.8c-0.3,1.7-0.6,2.7-1.1,4.4l-4.6,15.7h-4.9l-4.1-15.1 c-0.4-1.4-0.9-3.4-1.2-5.1c0,1.7-0.1,3.4-0.2,5.2l-1,15h-5.8l2.7-28.8h7.4l3.8,14.4c0.5,2.1,0.7,3.1,1,4.6c0.2-1.5,0.6-3,1-4.7 l3.9-14.3h7.4l2.6,28.8H994.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheta);
export default __webpack_public_path__ + "static/media/theta.fa84caae7ded0c154ee5226ab6af1788.svg";
export { ForwardRef as ReactComponent };